/**
 * Visio List View Filter Handler
 */
export function initVisioListFilter() {
	const filterContainer = document.getElementById('visio-list-filter');
	const listContent = document.getElementById('visio-list-content');
	if (!filterContainer || !listContent) return;

	const searchInput = filterContainer.querySelector('input[name="visio_search"]');
	const fromInput = filterContainer.querySelector('input[name="visio_from"]');
	const toInput = filterContainer.querySelector('input[name="visio_to"]');
	const statusSelect = filterContainer.querySelector('select[name="visio_status"]');

	function applyFilters() {
		const search = (searchInput?.value || '').toLowerCase().trim();
		const fromDate = fromInput?.value || '';
		const toDate = toInput?.value || '';
		const status = statusSelect?.value || 'all';

		const dayGroups = listContent.querySelectorAll('.visio-day-group');

		dayGroups.forEach((group) => {
			const groupDate = group.dataset.date || '';
			const cards = group.querySelectorAll('.visio-session-card');
			let visibleCount = 0;

			// Date range filter on group level
			if (fromDate && groupDate < fromDate) {
				group.style.display = 'none';
				return;
			}
			if (toDate && groupDate > toDate) {
				group.style.display = 'none';
				return;
			}

			cards.forEach((card) => {
				let show = true;

				// Search by student name
				if (search && !(card.dataset.studentName || '').includes(search)) {
					show = false;
				}

				// Status filter
				if (status !== 'all' && card.dataset.status !== status) {
					show = false;
				}

				card.style.display = show ? '' : 'none';
				if (show) visibleCount++;
			});

			// Hide day group if no visible cards
			group.style.display = visibleCount > 0 ? '' : 'none';
		});
	}

	// Debounce search
	let searchTimeout;
	if (searchInput) {
		searchInput.addEventListener('input', () => {
			clearTimeout(searchTimeout);
			searchTimeout = setTimeout(applyFilters, 300);
		});
	}

	if (fromInput) fromInput.addEventListener('change', applyFilters);
	if (toInput) toInput.addEventListener('change', applyFilters);
	if (statusSelect) statusSelect.addEventListener('change', applyFilters);
}
